<template>
  <div class="new-upload-box clearfix">
    <div v-if="view == 'arrange' || uploadList.length < 2">
      <div
          class="new-upload-list"
          :style="'width: ' + width + 'px; height: ' + height + 'px;'"
          v-for="(item, index) in uploadList"
          :key="index"
      >
        <template v-if="item.status === 'finished'">
          <span
              class="pdf-box ellipsis"
              v-if="/(.pdf)$/i.test(item.response.data.url)"
              @click="clickFile(item.response.data.url)"
          ></span>
          <span
              class="inner-pic"
              :style="'width: ' + width + 'px; height: ' + height + 'px;'"
              v-else
          >
            <img :src="item.response.data.url" @click="getBigPic(index)"/>
          </span>
          <div class="upload-list-cover" v-if="isEdit">
            <Icon type="md-remove" @click.native="handleRemove(index)"></Icon>
          </div>
          <div
              class="upload-hover-title"
              @click="clickFile(item.response.data.url)"
              v-if="/(.pdf)$/i.test(item.response.data.url)"
          >
            {{ item.response.data.oldName }}
          </div>
          <div class="upload-hover-title" @click="getBigPic(index)" v-else>
            {{ item.response.data.oldName }}
          </div>
        </template>
        <template v-else>
          <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
        </template>
      </div>
      <span
          class="upload-btn-box"
          v-if="isEdit"
          v-show="  uploadList.length < maxLength"
          :style="'width: ' + width + 'px; height: ' + height + 'px;'"
      >
        <Upload
            v-if="view == 'arrange' || uploadList.length < 2"
            ref="upload"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :before-upload="handleBeforeUpload"
            :action="actionUrl"
            :format="['jpg','jpeg','png', 'pdf']"
            :on-format-error="handleFormatError"
            :headers="uploadHeaders"
            multiple
            type="drag"
            :style="
            'display: inline-block;' +
            'width:' +
            width +
            'px;height: ' +
            height +
            'px;vertical-align: middle;'
          "
        >
          <div
              :style="
              'width: ' + width + 'px; height: ' + height + 'px; line-height: ' + height + 'px'
            "
          >
            <Icon type="md-add" size="20"></Icon>
          </div>
        </Upload>
      </span>
    </div>
    <div v-else>
      <div
          class="new-file-upload-box"
          :style="'width: ' + width + 'px; height: ' + height + 'px; line-height: ' + height + 'px'"
          v-if="uploadList.length > 1"
          @click="showUploadImg"
          @close="returnFileUuidList"
      >
        更多({{ uploadList.length }})
      </div>
      <vxe-modal v-model="isShowUploadImg" width="600" height="650" title="上传图片">
        <upload-img
            ref="uploadImg"
            @fileList="getUploadImgFileList"
            :isEdit="isEdit"
            :maxLength="maxLength"
        ></upload-img>
      </vxe-modal>

      <div
          class="upload-btn"
          :style="'width: ' + width + 'px; height: ' + height + 'px;line-height:' + height + 'px'"
          @click.stop="showUploadImg"
          v-if="isEdit"
      >
        <Icon type="md-add" size="20"></Icon>
      </div>
    </div>
    <div class="show-pic" v-if="isShowPicBox">
      <picture-viewer
          v-if="lookImageData && lookImageData.length > 0"
          :imgData="lookImageData"
          :picIndex="showPicIndex"
          @close="isShowPicBox = false"
      ></picture-viewer>
    </div>
  </div>
</template>

<script>
import auth from "@/utils/auth";
import UploadImg from "@/components/modal/NewUploadImg";
import PictureViewer from "@/components/common/PictureViewer";

const union = (...arr) => [...new Set(arr.flat())];
const assign = (o) => Object.assign({}, o);
const empties = [undefined, "", null, "null", {}, []];

export default {
  components: {
    UploadImg,
    PictureViewer,
  },
  props: {
    view: {
      type: String,
      default: "arrange", //显示方式  arrange 一行排列 , packup 收起的
    },
    row: {
      type: Object,
      default: null,
    },
    initFileList: {
      type: Array,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    maxLength: {
      type: Number,
      default: 5
    },
    width: {
      type: Number,
      default: 38,
    },
    height: {
      type: Number,
      default: 38,
    },
  },
  data() {
    return {
      uploadList: [],
      defaultList: [], // 默认图片
      actionUrl: "",
      uploadHeaders: {
        Authorization: auth.getAuth().token,
        token: auth.getAuth().token,
      },
      isShowUploadImg: false,
      showMore: false,
      isShowPicBox: false,
      lookImageData: [],
      showPicIndex: 0,
    };
  },
  watch: {
    initFileList: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.init(val);
      },
    },
  },
  mounted() {
    this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
  },
  methods: {
    init(initFileList) {
      // 编辑时 设置response属性
      this.uploadList = [];
      this.defaultList = [];
      if (initFileList && initFileList.length > 0) {
        initFileList.forEach((item) => {
          item.status = "finished";
          item.percentage = 100;
          if (empties.includes(item.oldFileName)) {
            item.oldFileName = item.oldName;
          } else {
            item.oldName = item.oldFileName;
          }
          item.name = item.oldName ? item.oldName : item.response ? item.response.data.oldName : null;
          if (empties.includes(item.response)) {
            item.response = {};
            item.response.data = {};

            let url = item.url ? item.url : item.response.data.url;
            let uuid = item.uuid ? item.uuid : item.response.data.uuid;
            let oldName = item.oldName ? item.oldName : item.response.data.oldName;
            item.response = {
              data: {
                url,
                uuid,
                oldName,
              },
            };
          }
          this.defaultList.push(assign(item));
        });
      }
      this.uploadList = union(this.uploadList, this.defaultList);
      this.returnFileUuidList();
    },
    clickFile(url) {
      window.open(url);
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
            "文件 " +
            file.name +
            " 格式不正确，请上传 jpg 或 png 或 jpeg 格式的图片, .pdf 格式的文件。",
      });
    },
    async handleRemove(i) {
      this.$XModal.confirm("您确定要删除该附件吗？").then((type) => {
        if (type === "confirm") {
          this.$refs.upload.fileList.splice(i, 1);
          this.uploadList = this.$refs.upload.fileList;
          this.returnFileUuidList();
        }
      });
    },
    handleSuccess(res, file) {
      if (res && res.status === 200 && res.data) {
        if (this.uploadList.length > 1) {
          this.showMore = true;
        }
        this.returnFileUuidList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    handleBeforeUpload(file) {
      if (file.size > 3072000) {
        this.$XModal.alert({
          message: "单个附件大小不能超过3M，请压缩后上传",
          status: "error",
        });
        return false;
      }
      let maxFileNum = this.maxLength ? this.maxLength : 5;
      if (this.$refs.upload.fileList.length > maxFileNum) {
        this.$XModal.alert({
          message: "最多只能上传" + maxFileNum + "张",
          status: "error",
        });
        return false;
      }
      this.uploadList = this.$refs.upload.fileList;
    },
    getUploadImgFileList(fileList) {
      if (fileList.length < 2) {
        this.isShowUploadImg = false;
      }
      this.init(fileList);
    },
    showUploadImg() {
      // console.log(this.uploadList);
      let isLoaded = this.uploadList.every((item) => {
        return item.status === "finished";
      });
      if (!isLoaded) {
        this.$XModal.alert({
          message: "附件还在上传中，请稍候。",
          status: "error",
        });
        return;
      } else {
        this.$refs.uploadImg.setList(this.uploadList);
        this.isShowUploadImg = true;
      }
    },
    returnFileUuidList() {
      let uuidList = [];
      this.uploadList.forEach((item) => {
        if (item.response && item.response.data) {
          uuidList.push(item.response.data.uuid);
        } else {
          uuidList.push(item.uuid);
        }
      });
      this.row.fileUuidList = uuidList;
      this.row.fileNewList = this.uploadList;
    },
    getBigPic(i) {
      this.lookImageData = [];
      this.uploadList.forEach((item, index) => {
        let regPdf = /(.pdf)$/i;
        if (!regPdf.test(item.oldName)) {
          item.name = item.oldName || item.response.data.oldName;
          item.url = item.response.data.url;
          item.bigImgUrl = item.response.data.url;
          this.lookImageData.push(item);
          if (index == i) {
            this.showPicIndex = this.lookImageData.length - 1;
          }
        }
      });
      this.isShowPicBox = true;
    },
  },
};
</script>

<style>
.add-box .vxe-table .vxe-cell .new-upload-box {
  text-indent: 0;
  padding: 5px;
}

.new-upload-list {
  display: block;
  float: left;
  background: #fff;
  border: 1px dashed #dcdee2;
  border-radius: 4px;
  margin-right: 3px;
  margin-bottom: 3px;
  line-height: 38px;
  position: relative;
}

.upload-btn-box {
  display: block;
  float: left;
}

.new-upload-list img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.new-file-upload-box {
  display: block;
  float: left;
  border-radius: 3px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  text-align: center;
  margin-right: 3px;
  border: 1px dashed #dcdee2;
  font-size: 12px;
}

.new-upload-box .ivu-progress {
  width: 96%;
  margin: 0 auto;
  position: relative;
}

.new-upload-box .upload-btn {
  display: inline-block;
  background: #fff;
  border: 1px dashed #dcdee2;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  /* vertical-align: middle; */
}

.new-upload-box .ivu-upload-drag {
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
}

.new-upload-list:hover .upload-list-cover {
  display: block;
}

.new-upload-list .upload-list-cover {
  display: none;
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.6);
  width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
}

.new-upload-list .upload-list-cover i {
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  margin: 0 auto;
  text-indent: 0;
  display: block;
  width: 100%;
  height: 100%;
  line-height: 20px;
}

.new-upload-list .inner-pic {
  display: block;
}

.new-upload-list .pdf-box2 {
  height: 180px;
  width: 180px;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
}
</style>
